export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
            <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500 flex items-center justify-center">
              <span className="font-heading text-2xl md:text-3xl font-black text-background-50">51</span>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950 mb-4">平台介绍</h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                51黑料吃瓜网成立于2020年，是国内领先的娱乐黑料爆料聚合平台。我们致力于为吃瓜群众提供最新、最全、最快的娱乐圈八卦资讯与黑料爆料内容。平台覆盖明星动态、综艺影视、网红圈层等多个维度的今日黑料，每日持续更新超过200条优质内容，已累计服务数百万吃瓜用户。我们坚持「即点即看」的产品理念，不做标题党、不搞虚假引流，让每一位用户都能在这里找到最真实、最劲爆的娱乐资讯。
              </p>
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-6 mt-6">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-primary-500"></div>
                  <span className="text-sm text-foreground-700">实时推送</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-accent-500"></div>
                  <span className="text-sm text-foreground-700">内容全面</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-secondary-500"></div>
                  <span className="text-sm text-foreground-700">即点即看</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}